export default __webpack_public_path__ + "4e13bb95171b0d0b13a5866a647036c4.png";